import { render, staticRenderFns } from "./ServicoOrcamentoEditarModal.vue?vue&type=template&id=48b14e88&scoped=true"
import script from "./ServicoOrcamentoEditarModal.vue?vue&type=script&lang=js"
export * from "./ServicoOrcamentoEditarModal.vue?vue&type=script&lang=js"
import style0 from "./ServicoOrcamentoEditarModal.vue?vue&type=style&index=0&id=48b14e88&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b14e88",
  null
  
)

export default component.exports